import { CustomerDetail } from '../../../../../features/users/views/CustomerDetailsTable';

const useEmailSettings = () => {
    const sendTestEmail = async (data: CustomerDetail) => {
        const response = await fetch('/api/admin/users/test-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data), // Convert the data object to a JSON string
        });

        // Check if the response is OK (status code 200-299)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the JSON response if successful
        const responseData = await response.json();
        return responseData;
    };

    const clearEmailSettings = async (data: CustomerDetail) => {
        const response = await fetch('/api/admin/users/reset-email', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data), // Convert the data object to a JSON string
        });

        // Check if the response is OK (status code 200-299)
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Parse the JSON response if successful
        const responseData = await response.json();
        return responseData;
    };

    const isDisabled = (data: CustomerDetail) => {
        if (data.emailType === 'GMAIL') {
            if (!data.emailAddress || data.emailAddress.trim() === '') return true;
        } else if (data.emailType === 'SMTP') {
            if (!data.emailAddress || data.emailAddress.trim() === '') return true;
            if (!data.emailUserAccount || data.emailUserAccount.trim() === '') return true;
            if (!data.smtpPassword || data.smtpPassword.trim() === '') return true;
            if (!data.smtpOutgoingHost || data.smtpOutgoingHost.trim() === '') return true;
            if (!data.smtpOutgoingPort || data.smtpOutgoingPort.trim() === '') return true;
        } else if (data.emailType === 'NONE') {
            return true;
        }

        return false;
    };

    return { sendTestEmail, isDisabled, clearEmailSettings };
};

export default useEmailSettings;
